﻿$.fn.dxCtrlPopupSaisieEmailTest = function custom_dxCtrlPopupSaisieEmailTest(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpopupsaisieemailtest dx-ctrl");
        this.createInstance(new cdxCtrlPopupSaisieEmailTest(this, option));
    }
    return this;
}

window.cdxCtrlPopupSaisieEmailTest = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.pop = null
    function mConstruit() {
        container.empty();
        container.remove()
        var dxTagBox = null
        Me.pop = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            shading: true,
            showMaximize: false,
            width: 500,
            height: "auto",
            title: "Saisie adresse email",
            onShown: function (e) { dxTagBox.focus() },
            contentTemplate: function (contentElement) {
                $("<div style='padding:10px;'>Saisissez les adresse emails ou envoyer votre email de test</div>").appendTo(contentElement)
                if (typeof option.bddCtrl.utiCourantParaJson.lst_email_test == "undefined") option.bddCtrl.utiCourantParaJson.lst_email_test = []
                option.bddCtrl.mSaveParaJsonUtilisateur();
                dxTagBox = $("<div/>").appendTo(contentElement).dxTagBox({
                    labelMode: 'floating',
                    label: "Adresses email de test",
                    placeholder:"Saisissez la liste des adresses email où tester votre message",
                    items: option.bddCtrl.utiCourantParaJson.lst_email_test,
                    value: option.bddCtrl.utiCourantParaJson.lst_email_test,
                    acceptCustomValue: true,
                    dropDownOptions: {
                        visible: false,
                        onShowing: function (e) { e.cancel = true }
                    },
                    onKeyDown: function (e) {
                        if (e.event.key == ";" || e.event.key == ",") {
                            e.component.blur()
                            window.setTimeout(function () { e.component.focus() }, 0)
                        } else {
                            if (option.bddCtrl.utiCourantParaJson.lst_email_test.length > 15) {
                                mNotify("Vous ne pouvez pas saisir plus de 15 adresses emails.", "warning", 6000)
                                e.component.blur()
                                window.setTimeout(function () { e.component.focus() }, 0)
                            }
                        }
                    },
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson.lst_email_test = ((e.value == null) ? [] : e.value)
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                    },
                    onCustomItemCreating: function (e) {
                        var newValue = e.text;
                        if (newValue != null && newValue.valideEmail() && !option.bddCtrl.utiCourantParaJson.lst_email_test.contains(newValue)) {
                            window.setTimeout(function () {
                                e.component.option({
                                    items: option.bddCtrl.utiCourantParaJson.lst_email_test,
                                    value: option.bddCtrl.utiCourantParaJson.lst_email_test
                                });
                            }, 0)
                            e.customItem = newValue;
                        } else {
                            e.customItem = null
                        }
                    }
                }).dxTagBox("instance")
                //$("<div style='padding-top:5px;font-style:italic;font-size:90%;'>(Quand vous envoyez un email en test, les tracking vue et click, les liens de visualisation navigateur et de désinscription sont désactivés dans le mail qui est envoyé)</div>").appendTo(contentElement)
                $("<br/>").appendTo(contentElement)
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (option.bddCtrl.utiCourantParaJson.lst_email_test.length == 0) {
                            mNotify("Aucune adresse email saisie pour votre envoi en test.", "warning", 6000)
                        } else {
                            option.onValidate(option.bddCtrl.utiCourantParaJson.lst_email_test)
                        }
                        Me.pop.hide()
                    },
                    function () { //annuler
                        Me.pop.hide();
                    }, null, "Envoyer")
            }
        }).dxCtrlPopupBase("instance")
        Me.pop.show()
    }

    this.element = function () { return container }
    this.component = function () { return Me; }

    mConstruit();
}